import { get, post, patch, del } from './apiHelper';

const publicPageCustomizationService = {
    // Obtener todas las personalizaciones de páginas públicas de una marca
    getCustomizations: async (marcaId) => {
        try {
            return await get(`public-pages/customization/${marcaId}`);
        } catch (error) {
            console.error('Error obteniendo personalizaciones de páginas públicas:', error);
            throw error;
        }
    },

    // Obtener personalización de una página específica
    getCustomization: async (marcaId, pageName) => {
        try {
            return await get(`public-pages/customization/${marcaId}/${pageName}`);
        } catch (error) {
            console.error(`Error obteniendo personalización de ${pageName}:`, error);
            throw error;
        }
    },

    // Crear personalización para una o más páginas
    createCustomization: async (marcaId, pages) => {
        try {
            // Si pages es un array, enviar todas las páginas
            // Si es un objeto, enviar como array con un solo elemento
            const pagesArray = Array.isArray(pages) ? pages : [pages];
            return await post(`public-pages/customization/${marcaId}`, { pages: pagesArray });
        } catch (error) {
            console.error('Error creando personalización de páginas públicas:', error);
            throw error;
        }
    },

    // Actualizar personalización de una página específica
    updateCustomization: async (marcaId, pageName, customization) => {
        try {
            return await patch(`public-pages/customization/${marcaId}/${pageName}`, customization);
        } catch (error) {
            console.error(`Error actualizando personalización de ${pageName}:`, error);
            throw error;
        }
    },

    // Eliminar personalización (reset a valores por defecto)
    deleteCustomization: async (marcaId, pageName) => {
        try {
            return await del(`public-pages/customization/${marcaId}/${pageName}`);
        } catch (error) {
            console.error(`Error eliminando personalización de ${pageName}:`, error);
            throw error;
        }
    },

    // Toggle activo/inactivo de una página
    toggleActive: async (marcaId, pageName, isActive) => {
        try {
            return await patch(`public-pages/customization/${marcaId}/${pageName}/toggle`, { isActive });
        } catch (error) {
            console.error(`Error cambiando estado de ${pageName}:`, error);
            throw error;
        }
    },

    // Subir imagen de fondo para una página específica
    uploadBackgroundImage: async (marcaId, pageName, imageFile) => {
        try {
            const formData = new FormData();
            formData.append('imagenFondo', imageFile);

            // Usar fetch directamente para FormData con multipart/form-data
            const baseUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3000/api';
            const url = `${baseUrl}/public-pages/customization/${marcaId}/${pageName}/background-image`;

            const storedData = localStorage.getItem('auth-storage-petitprime');
            const token = storedData ? JSON.parse(storedData)?.state?.token : null;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Authorization': token ? `Bearer ${token}` : '',
                    // No establecer Content-Type, el navegador lo hará automáticamente con el boundary
                },
                body: formData
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Error del servidor: ${response.status} - ${errorText}`);
            }

            return await response.json();
        } catch (error) {
            console.error(`Error subiendo imagen de fondo para ${pageName}:`, error);
            throw error;
        }
    },

    // Eliminar imagen de fondo de una página específica
    deleteBackgroundImage: async (marcaId, pageName) => {
        try {
            return await del(`public-pages/customization/${marcaId}/${pageName}/background-image`);
        } catch (error) {
            console.error(`Error eliminando imagen de fondo para ${pageName}:`, error);
            throw error;
        }
    }
};

export default publicPageCustomizationService;

